import * as config from './config.js';

$(".birthday").dateDropdowns({
    displayFormat: "ymd",
    submitFormat: "yyyy-mm-dd",
    dropdownClass: "form-control",
    yearLabel: '年',
    monthLabel: '月',
    dayLabel: '日',
    monthFormat: 'numeric',
    daySuffixes: false,
    monthSuffixes: false
});
// submit register
$('body').on('click', '.btn-register', function(e) {
    e.preventDefault();
    var otpForm = $('form.otp-form[data-pos="' + $(this).attr('data-pos') + '"]');
    var frmData = otpForm.serializeArray();
    var otpData = config.convertJsonData(frmData);
    $.ajax({
        url: '/register-otp',
        type: "POST",
        dataType: 'json',
        data: otpData,
        beforeSend: function() {
            config.showLoading($('#otp'));
            $('.invalid-message').remove();
            // $('.error-message').html('').addClass('d-none');
        },
        success: function(res) {
            config.hideLoading();
            if (res.status == 'error') {
                if (res.message !== undefined) {
                    config.showModal(config.modalInfo, config.modalTitle, res.message);
                } else if (res.messages !== undefined) {
                    $.each(res.messages, function(index, item) {
                        var elementInput = $('[name="' + index + '"]');
                        if (elementInput.prop('tagName').toLowerCase() == 'select') {
                            config.appendInvalidDiv(elementInput.parent().parent(), item);
                        } else {
                            config.appendInvalidDiv(elementInput.parent(), item);
                        }
                    });
                }
            } else if (res.status == 'success') {
                if (res.line_url == "") {
                    location.reload();
                } else {
                    location.href = res.line_url;
                }
            }
        },
        error: function() {
            $('.error-message').html('エラー').removeClass('d-none');
        }
    });
});
// click back after register success
$('body').on('click', '.btn-back', function() {
    location.reload();
});
$(function() {
    $('html, body').animate({ scrollTop: $(".main").offset().top }, '2000');

    var referrer = document.referrer;
    //console.log(referrer);
    config.breakStr();
    config.breakStrButton();
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
        if ($('.floating-banner').length>0) {
            $('body').css({
                'padding-bottom' : ($('.floating-banner').height() + 30) + 'px'
            });
        }
    }
});

// on click floating banner
$('body').on('click', '.floating-banner', function(e) {
    $('html, body').animate({ scrollTop: $(".otp-form").offset().top }, '2000');
});

// click reject_confirm
$('body').on('click', '.reject_confirm', function(e) {
    e.preventDefault();
    var reject_url = $('.urlCode').val();
    var urlhash = $('.urlhash').val();

    $.ajax({
        url: '/reject-mail',
        type: "POST",
        dataType: 'json',
        data: {
            reject_url: reject_url,
            urlhash: urlhash
        },
        success: function(res) {
            if (res.status == 'success') {
                $('#otp_reject').removeClass('d-none');
                $('#reject-msg').html(res.message);
                $('#otp_confirm').addClass('d-none');
            }
        },
        error: function() {
            $('.error-message').html('エラー').removeClass('d-none');
        }
    });
});